import { useCallback, useEffect, useState } from "react";
import { formatAuthCallbackError } from "../../../lib/authCallbackErrorMessage";
import { LOGGED_OUT_PARAM } from "../../../../shared/loggedOutParam";
import { redirectToSSO } from "../lib/sso";

type SignInState = "redirecting" | "errorOrLogout";

export function useSignInState() {
  const [signInState, setSignInState] = useState<SignInState>("redirecting");
  const [error, setError] = useState<string>();

  const params = new URLSearchParams(window.location.search);
  const urlError = params.get("error");
  const urlErrorDescription = params.get("error_description");
  const justLoggedOut = params.get(LOGGED_OUT_PARAM) === "true";

  const checkAndRedirect = useCallback(async () => {
    setSignInState("redirecting");
    setError(undefined);
    const err = await redirectToSSO();
    if (err) {
      setError(err);
      setSignInState("errorOrLogout");
    }
  }, []);

  useEffect(() => {
    if (urlError) {
      // oxlint-disable-next-line react/react-compiler -- EffectSetState: surfaces the URL callback error, otherwise kicks off the async SSO redirect
      setError(formatAuthCallbackError(urlError, urlErrorDescription));
      setSignInState("errorOrLogout");
      return;
    }
    if (justLoggedOut) {
      setSignInState("errorOrLogout");
      return;
    }
    void checkAndRedirect();
  }, [justLoggedOut, urlError, urlErrorDescription, checkAndRedirect]);

  return { signInState, error, justLoggedOut, checkAndRedirect };
}
